"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WallboardSchema = void 0;
const model_schema_1 = require("../base/model.schema");
const yup_1 = require("yup");
const Queue = (0, yup_1.object)({
    name: (0, yup_1.string)().required(),
    id: (0, yup_1.string)().required(),
});
const Group = (0, yup_1.object)({
    name: (0, yup_1.string)().required(),
    ids: (0, yup_1.array)((0, yup_1.string)()).default([]),
});
exports.WallboardSchema = model_schema_1.Schema.shape({
    wallboardID: (0, yup_1.number)().required(),
    config: (0, yup_1.object)({
        connectURL: (0, yup_1.string)().required(),
        key: (0, yup_1.string)().required(),
        secret: (0, yup_1.string)().required(),
        region: (0, yup_1.string)().required(),
        accessToken: (0, yup_1.string)().notRequired(),
        companyName: (0, yup_1.string)().required(),
        companyLogoURL: (0, yup_1.string)().required(),
        dashboardName: (0, yup_1.string)().required(),
        queues: (0, yup_1.array)(Queue.required()).default([]),
        groups: (0, yup_1.array)(Group.notRequired()).default([])
    }).default(undefined),
});
